// Currency formatting helper for the dashboard (kitchen, take-order,
// tabs, reports). Mirror of frontend/customer-app/src/utils/currency.js
// — keeping them in sync by hand is intentional. The two apps don't
// share a workspace and a shared package would be over-engineering for
// pilot scale. If you change the formatter map below, change it there
// too.
//
// Conventions:
//   ETB  → "Br 12.50"
//   EUR  → "€12.50"
//   USD  → "$12.50"

const FORMATTERS = {
  ETB: (n) => `Br ${n.toFixed(2)}`,
  EUR: (n) => `€${n.toFixed(2)}`,
  USD: (n) => `$${n.toFixed(2)}`,
};

export function formatPrice(amount, currency) {
  const num = Number(amount || 0);
  const code = (currency || "ETB").toUpperCase();
  const fmt = FORMATTERS[code];
  if (fmt) return fmt(num);
  return `${code} ${num.toFixed(2)}`;
}

export function currencySymbol(currency) {
  const code = (currency || "ETB").toUpperCase();
  if (code === "ETB") return "Br";
  if (code === "EUR") return "€";
  if (code === "USD") return "$";
  return code;
}
